import React from "react";
import { IoIosArrowRoundForward } from "react-icons/io";
import styles from "./thankyou.module.css";
import rewardImage from "images/headerimges/mis-survey/celebration.png";
import { Link } from "react-router-dom";
import { useSurveySectionContent } from "context/survey-track/SurveySectionContext";

const RewardPage = () => {
	const { currentSurveySection } = useSurveySectionContent();

	return (
		<section className={styles.reward_container}>
			<h2>Congratulations</h2>
			<img src={rewardImage} alt="congratulations" />

			<section className={styles.reward_note}>
				<p>You just got back</p>
				<h2>{currentSurveySection?.rewardPrice ?? ""} Naira</h2>

				<p>Finish the next section to claim!</p>
			</section>

			<section className={styles.reward_other_section}>
				<Link to={currentSurveySection?.nextSectionUrl ?? "#"} replace>
					Start next section{" "}
					<IoIosArrowRoundForward color="white" size={24} />
				</Link>
			</section>
			<p>your input makes a difference</p>
		</section>
	);
};

export default RewardPage;
